import React, { useState, useEffect } from 'react';
import './App.css';
import { Provider, rootStore } from "./models/root";
import './firebase.js';
import EventEmitter from './events.js';
import apis from "./assets/js/apis.js";
import axios from 'axios';
import {
    Routes,
    Route,
  } from "react-router-dom";
import Website from './screens/website.js';
import BeforeSignUp from './screens/beforeSignUp';
import Comparison from './screens/comparison';
import Admissible from './screens/admissible';
import Ambassador from './screens/ambassador';

import SignUp from './screens/signUp.js'
import Vision from './screens/vision';

import SignIn from './screens/mainlogin.js'
import Home from './screens/home';
import IdeaFunctions from './screens/ideafunctions';
import IdeaCollection from './screens/ideacollection';
import Nominate from './screens/nominate';
import College from './screens/college';
import ImproveIdea from './screens/improveidea';
import Pricing from './screens/pricing';
//so if user tries to navigate to page which is beyond access due to non-signup
//or college unselection or unnomination these still apply below and ofc have 
//to be redirected 
const USER_CORRECT__TOKEN_RECEIVED = 1;
const COLLEGE_UNSELECTED = 2;
const NOMINATION_LEFT = 3;
const SEND_HOME_OR_TO_PAGE_WANTED = 4;

const NO_USERNAME_OR_PASSWORD = 56;
const USERNAME_AND_PASSWORD = 57;




function App() {

   const [windowDimenion, detectHW] = useState({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    })
  
    const detectSize = () => {
      detectHW({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight,
      })
    }
  
    useEffect(() => {
      window.addEventListener('resize', detectSize)
  
      return () => {
        window.removeEventListener('resize', detectSize)
      }
    }, [windowDimenion])

  
  const [loading,setLoading] = useState(true); 
  EventEmitter.subscribe('startProcess',(event)=>startProcess(event));

  function startProcess(event){
   if(event.event==NO_USERNAME_OR_PASSWORD){
      console.log(5)
      setLoading(false);
   }
   else if(event.event==USERNAME_AND_PASSWORD){
      console.log(6)
      axios.post(apis.access,{"username":event.username,"password":event.password}).
          then(response=>{

            const options = {
               headers: {'Authorization': `Bearer ${response.data.access_token}`}
             };  
            return axios.get(apis.sendvariables,options)
          },error=>{;}).then(response=>{
               if(response.data.nominated == true){
                  if(window.location.pathname=("/"||"/beforeSignUp"||"/signIn"||"/signUp"||"/college"||"/home")){
                     setLoading(false);
                  }
                  else {
                     setLoading(false);
                  }
               }
               else if(response.data.nominated==false){
                  if(response.data.college==true){
                     setLoading(false);
                  }
                  else if (response.data.college=false){
                     setLoading(false);
                  }
               }
            },error=>{;})
   }
  }

  return (
      <div>
         {
         // windowDimenion.winWidth>700?
         // <div class="w-fullgrid grid-cols-1 place-content-center">
         //    <div class="m-auto">
         //       <div>We haven't optimised Horsey for the web yet!</div>
         //       <div>Please visit Horsey on a mobile device</div>
         //    </div>
         // </div>:
         <div>
      <Provider value={rootStore}>
      {loading?<div></div>:
      
      
      <Routes>
            <Route path='/' element={<Website/>}/>
            <Route path="/signIn" element={<SignIn/>}/>
            <Route path="/signUp" element={<SignUp/>}/>
            <Route path='/beforeSignUp' element={<BeforeSignUp/>}/>
            <Route path='/ambassador' element={<Ambassador/>}/>
            <Route path='/vision' element={<Vision/>}/>
            <Route path='/admissible' element={<Admissible/>}/>
            <Route path='/comparison' element={<Comparison/>}/>
            <Route path='/home' element={<Home/>}/>
            <Route path='/college' element={<College/>}/>
            <Route path='/ideafunctions' element={<IdeaFunctions/>}/>
            <Route path='/ideacollection' element={<IdeaCollection/>}/>
            <Route path='/nominate' element={<Nominate/>}/>
            <Route path='/improveidea' element={<ImproveIdea/>}/>
            <Route path='/pricing' element={<Pricing/>}/>
      </Routes>
      
      }
      </Provider>
      </div>}</div>
    
  );
}

export default App;

// import Home from './screens/home.js';
// 
// import Nominate from './screens/nominate.js';
// import SignIn from './screens/mainlogin.js'
// import SignUp from './screens/signUp.js'
// import College from './screens/college.js'
// import IdeaCollection from './screens/ideacollection.js';
// import IdeaFunctions from './screens/ideafunctions.js';
// import Payment_Page from './screens/payment_page';
// import {
//   BrowserRouter as Router,
//   Switch,
//   Route,
// } from "react-router-dom";


// import { createBrowserHistory } from 'history';
// <Route exact path='/paymentPage'>
// <Payment_Page/>
// </Route>
// <Route path="/beforeSignUp">
// <BeforeSignUp/>
// </Route>
// <Route path="/signIn">
// <SignIn/>
// </Route>
// <Route path="/signUp">
// <SignUp/>
// </Route>
// <Route path="/college">
// <College/>
// </Route>
// <Route path="/home">
// <Home/>
// </Route>
// <Route path="/idea">
// <IdeaFunctions/>
// </Route>
// <Route path="/myIdeas">
// <IdeaCollection/>
// </Route>
// <Route path="/nominate">
// <Nominate/>
// </Route>
